import { useState, useEffect } from 'react';

/************************************************************************

  USAGE of Window resize

  This hook will return {height, width} whenever the window is resized
  Use it on components that require adjusting to display width

************************************************************************/
const useWindowResize = (): { height: number; width: number } => {
  const [windowSize, setWindowSize] = useState({
    width: null as number,
    height: null as number,
  });
  useEffect(() => {
    // Handler to call on window resize
    const handleResize = () => {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Window might not exist on Gatsby static generator
    if (window) {
      // Add event listener
      window.addEventListener('resize', handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
    }
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
};

export default useWindowResize;
